// src/views/Tarjetas/EliminarHabi.jsx
import React, { useState } from "react";
import apiRoutes from "../../../api/apiRoutes";
import { apiFetchJson } from "../../../utils/http";

function EliminarHabi({
  registro = {}, // { id, eessNombre, tarjetaNumero } para EE.SS. habilitadas
  onClose = () => {},
  onDeleted = () => {},
}) {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  // Es modal de EE.SS. habilitadas si viene el nombre de estación
  const isEESS = !!(registro.eessNombre || registro.eess || registro.nombre);
  const eessNombre =
    registro.eessNombre ?? registro.eess ?? registro.nombre ?? "";

  // 🔧 clave: contemplar "tarjetaNumero" además de otros posibles alias
  const nroTarjeta =
    registro.tarjetaNumero ??
    registro.tarjeta ??
    registro.numeroTarjeta ??
    registro.numero ??
    "";

  const handleDelete = async () => {
    setError("");
    setLoading(true);
    try {
      const id = registro.id;
      if (!id) throw new Error("Id del registro no encontrado.");
      // DELETE real
      await apiFetchJson(apiRoutes.eessHabilitadas.delete(id), {
        method: "DELETE",
      });

      onDeleted(registro); // avisar al padre
      onClose();
    } catch (e) {
      setError(e?.message || "No fue posible eliminar el registro.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="w-full">
      <div className="px-6 py-4 border-b">
        <h2 className="section-title">
          {isEESS ? "Eliminar EE.SS. habilitada" : "Eliminar Productos Tarjeta"}
        </h2>
      </div>

      <div className="px-6 pt-4">
        <div className="mb-4 px-4 py-3 text-sm" style={{ color: "#1e72c0ff" }}>
          ¿Está seguro que desea eliminar este registro?
        </div>

        <div className="mb-2 bg-gray-50 px-6 py-6">
          <div className="text-center space-y-3">
            {isEESS ? (
              <>
                <div>
                  <span className="text-gray-500 mr-1">EE.SS.:</span>
                  <span className="font-medium">{eessNombre || "—"}</span>
                </div>
                <div>
                  <span className="text-gray-500 mr-1">Tarjeta:</span>
                  <span className="font-medium">{nroTarjeta || "—"}</span>
                </div>
              </>
            ) : (
              // (modo productos — lo dejamos igual)
              <>
                <div>
                  <span className="text-gray-500 mr-1">Producto:</span>
                  <span className="font-medium">
                    {registro.productoCodigo
                      ? `${registro.productoCodigo} - `
                      : ""}
                    {registro.productoDescripcion || "—"}
                  </span>
                </div>
                <div>
                  <span className="text-gray-500 mr-1">Tarjeta:</span>
                  <span className="font-medium">{nroTarjeta || "—"}</span>
                </div>
              </>
            )}
          </div>
        </div>

        {error && <div className="text-sm text-red-600 mb-2">{error}</div>}
      </div>

      <div className="px-6 py-4 border-t flex items-center gap-2 modal-footer">
        <button className="btn-fil" onClick={handleDelete} disabled={loading}>
          {loading ? "Eliminando…" : "Eliminar"}
        </button>
        <button className="btn-fil" onClick={onClose}>
          Nueva consulta
        </button>
      </div>
    </div>
  );
}

export default EliminarHabi;
